module.exports = __webpack_public_path__ + "static/media/overdue2.f7218ed9.svg";